import React, { Component } from "react";
import PropTypes from "prop-types";
import { firebaseAuth, ui } from "config/constants";
import AppRouter from "./AppRouter";

export default class AppLoader extends Component {
  state = {
    authed: false,
    user: null,
    loading: true
  };

  static childContextTypes = {
    fb: PropTypes.object
  };

  getChildContext() {
    return {
      fb: this.props.router
    };
  }

  componentDidMount() {
    if (typeof firebaseAuth.GoogleAuthProvider !== 'undefined') {
      var uiConfig = {
        signInSuccessUrl: "/",
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          'google.com'
          // firebaseAuth.GoogleAuthProvider.PROVIDER_ID,
          // firebaseAuth.FacebookAuthProvider.PROVIDER_ID,
          // firebaseAuth.TwitterAuthProvider.PROVIDER_ID,
          // firebaseAuth.GithubAuthProvider.PROVIDER_ID,
          // firebaseAuth.EmailAuthProvider.PROVIDER_ID,
          // firebaseAuth.PhoneAuthProvider.PROVIDER_ID
        ],
        // Terms of service url.
        tosUrl: "/"
      };

      // ui.start("#firebaseui-auth-container", uiConfig);
    }
    this.removeListener = firebaseAuth().onAuthStateChanged(user => {
      this.setState({
        authed: !!user,
        user: user,
        loading: false
      });
    });
  }
  componentWillUnmount() {
    this.removeListener();
  }

  render() {
    return (
      <div className="AppLoader">
        {this.state.loading ? <span>Loading</span> : <AppRouter />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AppLoader.jsx